
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetNtype2Off as ObiMosfetNtype2OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ntype-2-off.js';
 
 
 

 
 export const ObiMosfetNtype2Off = createComponent({
   react: React,
   tagName: 'obi-mosfet-ntype-2-off',
   elementClass: ObiMosfetNtype2OffElement,
   events: {
     
   }
  });
 
 